import { Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ExportPatientDataModal } from '../../components';
import { useExportPatientData } from '../../hooks';
import { enqueueSnackbar } from 'notistack';
import { ChevronLeft } from '@mui/icons-material';
import { FC, useEffect, useState } from 'react';
import {
  ButtonContainer,
  OuterTitleContainer,
  StyledButton,
} from '../PatientScreenRouter/styles';

interface PatientHeaderProps {
  id: string;
  first_name: string | undefined;
  last_name: string | undefined;
}

export const PatientHeader: FC<PatientHeaderProps> = ({
  id,
  first_name,
  last_name,
}) => {
  const navigate = useNavigate();
  const {
    isLoading: isLoadingExportPatientData,
    result: resultExportPatientData,
    exportData: requestExportPatientData,
  } = useExportPatientData();

  const [exportPatientDataModalOpen, setExportPatientDataModalOpen] =
    useState(false);

  useEffect(() => {
    if (resultExportPatientData) {
      setExportPatientDataModalOpen(false);
      enqueueSnackbar('Patient data exported successfully', {
        variant: 'success',
      });
    }
  }, [resultExportPatientData]);

  const handleBack = () => {
    navigate('/patients');
  };

  const handleExportPatientDataClick = () => {
    setExportPatientDataModalOpen(true);
  };
  return (
    <div style={{ marginBottom: '12px' }}>
      <ExportPatientDataModal
        open={exportPatientDataModalOpen}
        onClose={() => setExportPatientDataModalOpen(false)}
        patientId={id}
        requestExportPatientData={requestExportPatientData}
        isLoadingExportPatientData={isLoadingExportPatientData}
      />
      <OuterTitleContainer>
        <Link
          underline='always'
          variant='h2'
          color='inherit'
          onClick={handleBack}
          component='button'
        >
          <Typography
            variant='h2'
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ChevronLeft fontSize='inherit' /> {first_name} {last_name}
          </Typography>
        </Link>
        <ButtonContainer>
          <StyledButton
            variant='contained'
            onClick={handleExportPatientDataClick}
          >
            Export Patient Data
          </StyledButton>
        </ButtonContainer>
      </OuterTitleContainer>
    </div>
  );
};
